import React from 'react';
import { Input, Button } from 'antd';
import styles from './Login.module.scss';

interface LoginComponentProps {
  email: string;
  setEmail: (email: string) => void;
  password: string;
  setPassword: (password: string) => void;
  handleLogin: () => void;
}

const Login: React.FC<LoginComponentProps> = ({
  email, setEmail, password, setPassword, handleLogin
}) => {
  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginBox}>
        <h1>로그인</h1>
        <form onSubmit={(e) => { e.preventDefault(); handleLogin(); }}>
          <Input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className={styles.inputField}
          />
          <Input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className={styles.inputField}
          />
          <Button type="primary" htmlType="submit" className={styles.loginButton}>
            Login
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Login;
